import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rotate-icon',
  templateUrl: './rotate-icon.component.html',
  styleUrls: ['./rotate-icon.component.scss'],
  standalone: false,
})
export class RotateIconComponent {
  @Input() imageUrl: string;
  @Input() animate: boolean;
}
